import _ from 'lodash';
import { Link } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import VisibilitySensor from 'react-visibility-sensor';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';

import './index.css';
import 'animate.css';
import '../../static/css/animate.css';
import Sidebar from '../../components/sidebar';
import NavbarInner from '../../components/navbar-inner';
import PostPayment from '../../components/post-payment';
import Notification from '../../components/notification';
import SchedulerModal from '../../components/scheduler-modal';
import { getMigration, getMigrations, setupFullMigration, newMigration, setDeleteMigration, setMigration, createRelations } from '../../store/actions/Migration';

const Dashboard = () => {
    const dispatch = useDispatch();
    const [activeSection] = useState();
    const [newModal, setNewModal] = useState(false);
    const [companyName, setCompanyName] = useState('');
    const [detailsModal, setDetailsModal] = useState(false);
    const [notification, setNotification] = useState(false);
    const [privateAppToken, setPrivateAppToken] = useState('');
    const [paymentStatus, setPaymentStatus] = useState('unpaid');
    const [notificationMessage, setNotificationMessage] = useState('');
    const [notificationSeverity, setNotificationSeverity] = useState('success');
    const [isScheduleMigrationModalOpen, setIsScheduleMigrationModalOpen] = useState(false);
    const [isCustomObjectMigrationDisabled, setIsCustomObjectMigrationDisabled] = useState(false);

    const [features, setFeatures] = useState({});
    const [sourceProvider, setSourceProvider] = useState('salesforce');

    const [deleteMigration, setDelete] = useState({});
    const { migration, migrations, hsAuth, hsAuthSource, sfAuth, pipedriveAuth } = useSelector(st => st.Migration);


    useEffect(() => { dispatch(getMigrations()) }, []);

    useEffect(() => {
        let migrationObj = migration;
        migrationObj['paymentStatus'] = paymentStatus;
        setMigration(migration);
    }, [paymentStatus]);

    const createMigration = () => {
        if (!companyName) return;
        dispatch(newMigration({ companyName, privateAppToken, sourceProvider, features }))
    }

    useEffect(() => {
        if (sourceProvider === 'pipedrive') {
            setIsCustomObjectMigrationDisabled(true);
            setFeatures({ ...features, ['custom']: false });
        } else {
            setIsCustomObjectMigrationDisabled(false);
        }
    }, [sourceProvider]);

    const stripePromise = loadStripe(process['env']['REACT_APP_STRIPE_PUB_KEY']);
    const stripePISecret = new URLSearchParams(window['location']['search']).get('payment_intent_client_secret');

    const detailsPopup = (migration) => {
        setDetailsModal(true);
        dispatch(getMigration({ key: migration['key'], type: 'none' }));
    }
    return (
        <div className='dashboard-page active'>
            <Notification open={notification} setOpen={setNotification} message={notificationMessage} severity={notificationSeverity} />
            {stripePISecret &&
                <Elements stripe={stripePromise}>
                    <PostPayment
                        notificationSetter={setNotification}
                        fullMigrationSetter={setPaymentStatus}
                        notificationMessageSetter={setNotificationMessage}
                        notificationSeveritySetter={setNotificationSeverity}
                    />
                </Elements>
            }
            <Sidebar activeSection={activeSection} />
            <VisibilitySensor>
                <div className='content'>
                    <NavbarInner />
                    <div className='dashboard-area'>
                        <div className='title-area'>
                            <h2>My Dashboard</h2>
                            <a className='btn-style-one' onClick={() => setNewModal(true)}>New Migration</a>
                        </div>
                        {migrations.length == 0 ?
                            <div className='content-box'>
                                <h3>You have not started any migration projects yet.</h3>
                                <p>We're ready to move some data when you are! <i className='icon'><img src={require('../../static/images/duck.png')} alt='' /></i></p>
                            </div>
                            :
                            <div className='content-box'>
                                {/* after migration show this div */}
                                <div className='table-area checkout-table'>
                                    <div class='table-responsive'>
                                        <table class='table'>
                                            <thead>
                                                <tr>
                                                    <th>Status</th>
                                                    <th>Name</th>
                                                    <th>From</th>
                                                    <th>To</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {migrations.map(migration => {
                                                    let status = 'In-Progress';
                                                    if (['created', 'connected', 'field-mapping'].includes(migration['status'])) status = 'Drafted';
                                                    else if (['sample', 'activated', 'in-progress'].includes(migration['status']) && migration['inQueueTasks'] > 0) status = 'In-Progress';
                                                    else if (['sample', 'activated'].includes(migration['status']) && migration['inQueueTasks'] == 0) status = 'Stopped';
                                                    else if (['completed', 'in-progress'].includes(migration['status']) && migration['inQueueTasks'] == 0) status = 'Completed';
                                                    return (
                                                        <tr>
                                                            <td>
                                                                <div className='company-data'>
                                                                    <i className={`icon-circle ${status}`}></i> {status}
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className='company-data'>{migration['companyName']}</div>
                                                                {!['created', 'connected', 'field-mapping'].includes(migration['status']) &&
                                                                    <>
                                                                        {/* <button className='without-icon' onClick={() => detailsPopup(migration)}>See details</button> */}
                                                                        {/* <br /> */}
                                                                        <Link className='without-icon' to={`/reportLog?key=${migration['key']}`}>See details</Link>
                                                                    </>
                                                                }
                                                                {/* <div className='company-data'> <h4>{migration['key'].split('-')[0]}</h4> </div> */}
                                                            </td>
                                                            <td>
                                                                <div className='company-data'>
                                                                    {migration['sourceProvider'] == 'salesforce' ?
                                                                        <><i className='icon'><img src={require('../../static/images/salesforce.png')} alt='' /></i> Salesforce</>
                                                                        : migration['sourceProvider'] == 'pipedrive' ?
                                                                            <><i className='icon'><img src="https://www.pipedrive.com/favicon.ico" alt='' style={{ width: '20px', height: '20px' }} /></i> Pipedrive</>
                                                                            : <><i className='icon'><img src={require('../../static/images/hubspot.jpg')} alt='' /></i> HubSpot</>
                                                                    }
                                                                </div>
                                                                {migration['sourceAccountId'] ?
                                                                    <Link to='#' style={{ cursor: 'default' }} >{migration?.['sourceAccountId']}</Link>
                                                                    : migration['sourceProvider'] == 'hubspot' ?
                                                                        <a href={`${hsAuthSource}&state=${migration['key']}_source`}>Connect</a>
                                                                        : migration['sourceProvider'] == 'pipedrive' ?
                                                                            <a href={`${pipedriveAuth}&state=${migration['key']}`}>Connect</a>
                                                                            : <a href={`${sfAuth}&state=${migration['key']}`}>Connect</a>
                                                                }
                                                            </td>
                                                            <td>
                                                                <div className='company-data'>
                                                                    <i className='icon'><img src={require('../../static/images/hubspot.jpg')} alt='' /></i> HubSpot
                                                                </div>
                                                                {migration['hubspotPortalId'] ?
                                                                    <Link to='#' style={{ cursor: 'default' }} >{migration['hubspotPortalId']}</Link>
                                                                    : <a href={`${hsAuth}&state=${migration['key']}`}>Connect</a>
                                                                }
                                                            </td>
                                                            <td>
                                                                {
                                                                    status == 'Drafted' ?
                                                                        <div>
                                                                            <Link class='ml-3' to={`/NewMigration?key=${migration['key']}`}> <i className='fa fa-edit' style={{ 'fontSize': '20px' }} /> </Link>
                                                                            <Link class='ml-4' to='#' onClick={() => setDelete(migration)}> <i className='fa fa-trash' style={{ 'fontSize': '20px' }} /> </Link>
                                                                        </div>
                                                                        : migration['paymentStatus'] == 'paid' && migration['status'] == 'sample' ? <button className='without-icon' onClick={() => dispatch(setupFullMigration(migration['key']))}> Run full migration </button>
                                                                            : migration['paymentStatus'] == 'unpaid' && migration['inQueueTasks'] == 0 ? 'Purchase full migration'
                                                                                // : migration['paymentStatus'] == 'unpaid' && migration['inQueueTasks'] == 0 ? <button className='without-icon' onClick={() => setPaymentModal(true)}> Purchase full migration </button>
                                                                                : migration['status'] == 'in-progress' && migration['inQueueTasks'] == 0 ? <button className='without-icon' onClick={() => dispatch(createRelations(migration['key']))}> Run Object Relations </button>
                                                                                    : migration['status'] === 'sample' ? 'Running Sample'
                                                                                        : ['in-progress'].includes(migration['status']) && migration['inQueueTasks'] > 0 ? 'Running Full Migration'
                                                                                            : ['completed', 'in-progress'].includes(migration['status']) && migration['inQueueTasks'] == 0 ? 'Migration Completed'
                                                                                                : <Link className='btn-style-two' to={`/reportLog?key=${migration['key']}`}>Details</Link>
                                                                }
                                                            </td>
                                                        </tr>
                                                    )
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div >
            </VisibilitySensor>
            {/* ------------------New Migration Modal----------------- */}
            <Modal
                centered
                isOpen={newModal}
                className='modal-payment migration-modal-new'
                aria-labelledby='contained-modal-title-vcenter'
            >
                <ModalHeader toggle={() => setNewModal(!newModal)}>
                    <h2>Start a new migration</h2>
                </ModalHeader>
                <ModalBody>
                    <div className='payment-box'>
                        <div className='title-area mb-'>

                        </div>
                        <ValidatorForm className='validatorForm'>
                            <Grid container className='group-input' alignItems='flex-end'>
                                <Grid item xs={12}>
                                    <label className='mb-0 mt-2' style={{ fontSize: '15px' }}>Migration Name*</label>
                                    <TextValidator
                                        fullWidth
                                        type='text'
                                        margin='dense'
                                        name='companyName'
                                        autoComplete='off'
                                        value={companyName}
                                        validators={['required']}
                                        placeholder='Migration 001'
                                        errorMessages={['Name can not be empty']}
                                        onChange={(e => setCompanyName(e['target']['value']))}
                                    />
                                </Grid>
                                <div className='checkbox-boxes'>
                                    <p>Select data source*</p>
                                    <div className="checkbox-group">
                                        <div className="checkbox">
                                            <label className="checkbox-wrapper">
                                                <input
                                                    type="radio"
                                                    className="checkbox-input"
                                                    checked={sourceProvider === 'salesforce'}
                                                    onChange={() => setSourceProvider('salesforce')}
                                                />
                                                <span className="checkbox-tile">
                                                    <span className="checkbox-label">From Salesforce to HubSpot</span>
                                                    <span className="checkbox-icon">
                                                        <img src={require('../../static/images/salesforce-hubsopt.png')} alt='' />
                                                    </span>

                                                </span>
                                            </label>
                                        </div>

                                        <div className="checkbox">
                                            <label className="checkbox-wrapper">
                                                <input
                                                    type="radio"
                                                    className="checkbox-input"
                                                    checked={sourceProvider === 'hubspot'}
                                                    onChange={() => setSourceProvider('hubspot')}
                                                />
                                                <span className="checkbox-tile">
                                                    <span className="checkbox-label">From HubSpot to HubSpot</span>
                                                    <span className="checkbox-icon">
                                                        <img src={require('../../static/images/hubsopt-hubsopt.png')} alt='' />
                                                    </span>

                                                </span>
                                            </label>
                                        </div>

                                        <div className="checkbox">
                                            <label className="checkbox-wrapper">
                                                <input
                                                    type="radio"
                                                    className="checkbox-input"
                                                    checked={sourceProvider === 'pipedrive'}
                                                    onChange={() => setSourceProvider('pipedrive')}
                                                />
                                                <span className="checkbox-tile">
                                                    <span className="checkbox-label">From Pipedrive to HubSpot</span>
                                                    <span className="checkbox-icon">
                                                        <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
                                                            <img src="https://www.pipedrive.com/favicon.ico" alt="Pipedrive" style={{ width: '40px', height: '40px', borderRadius: '8px' }} />
                                                            <span style={{ fontSize: '20px' }}>→</span>
                                                            <img src={require('../../static/images/hubspot.jpg')} alt="HubSpot" style={{ width: '40px', height: '40px', borderRadius: '8px' }} />
                                                        </span>
                                                    </span>
                                                </span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className='checkbox-boxes'>
                                    <p>Data Migration Options*</p>
                                    <div className='migration-checkbox'>
                                        <div class="align-left">
                                            <input type="checkbox" name="object" id="object" onClick={({ target }) => setFeatures({ ...features, ['object']: target['checked'] })} checked={features['object']} />
                                            <label for="object">Object data migration</label>
                                        </div>
                                        <div class="align-left">
                                            <input type="checkbox" name="engagement" id="engagement" onClick={({ target }) => setFeatures({ ...features, ['engagement']: target['checked'] })} checked={features['engagement']} />
                                            <label for="engagement">Engagement data migration</label>
                                        </div>
                                        {!isCustomObjectMigrationDisabled &&
                                            <div class="align-left">
                                                <input type="checkbox" name="custom" id="custom" onClick={({ target }) => setFeatures({ ...features, ['custom']: target['checked'] })} checked={features['custom']} />
                                                <label for="custom">Custom objects migration</label>
                                            </div>
                                        }
                                    </div>
                                </div>
                                {/* <Grid item xs={12}>
                                    <label className='mb-0 mt-2' style={{ fontSize: '15px' }}>Data Migration Options*</label>
                                    <Select
                                        fullWidth
                                        value={type}
                                        id='supported-objects-multiple-checkbox'
                                        onChange={({ target }) => setType(target['value'])}
                                    >
                                        <MenuItem value={'Full migration'}> Full migration </MenuItem>
                                        <MenuItem value={'Soft data migration'}> Soft data migration </MenuItem>
                                    </Select>
                                </Grid> */}
                                {features['custom'] &&
                                    <Grid item xs={12}>
                                        <label className='mb-0 mt-2' style={{ fontSize: '15px' }}>HubSpot Private App Token (optional)</label>
                                        <TextValidator
                                            fullWidth
                                            type='text'
                                            margin='dense'
                                            autoComplete='off'
                                            name='privateAppToken'
                                            value={privateAppToken}
                                            // validators={['required']}
                                            errorMessages={['Provide HubSpot private app token']}
                                            placeholder='Please provide HubSpot private app token'
                                            onChange={(e => setPrivateAppToken(e['target']['value']))}
                                        />
                                    </Grid>
                                }
                            </Grid>
                            <div class="btn-group-bottom">
                                {/* {type == 'Full migration' &&
                                    <div class="align-left" style={{ fontSize: '14px' }}>
                                        <input type="checkbox" id="customObject" onClick={({ target }) => setCustom(target['checked'])} />
                                        <label for="customObject" style={{ padding: '10px', cursor: 'pointer' }}>I need support for custom objects</label>
                                    </div>
                                } */}
                                <button className='btn-style-one align-right' type='submit' onClick={createMigration}> Next </button>
                            </div>
                        </ValidatorForm>
                    </div>
                </ModalBody>
            </Modal>

            {/* ------------------Delete Migration Modal----------------- */}
            <Modal
                isOpen={deleteMigration['key']}
                className='modal-payment'
                aria-labelledby='contained-modal-title-vcenter'
                centered>
                <ModalBody>
                    <div className='payment-box'>
                        <div className='title-area text-center'> <h5>Delete Migration</h5> </div>
                        <p className='pt-2' style={{ 'fontSize': '17px' }}> Are you sure you want to delete {deleteMigration['companyName']} migration? </p>
                        <div className='text-center pt-3'>
                            <button className='btn-style-one' onClick={() => { dispatch(setDeleteMigration(deleteMigration['key'])); setDelete({}) }}> Yes </button>
                            <button className='mx-5 btn-style-two' onClick={() => setDelete({})}> No </button>
                        </div>
                    </div>
                </ModalBody>
            </Modal>

            {/* ------------------Schedule Migration Setup----------------- */}
            {isScheduleMigrationModalOpen && <SchedulerModal migrationType="PRIMARY" isScheduleMigrationModalOpen={isScheduleMigrationModalOpen} setIsScheduleMigrationModalOpen={setIsScheduleMigrationModalOpen} />}

        </div >
    );
};

export default Dashboard;